import { render, staticRenderFns } from "./ListaArrendamientos.vue?vue&type=template&id=581e717f&"
import script from "./ListaArrendamientos.vue?vue&type=script&lang=js&"
export * from "./ListaArrendamientos.vue?vue&type=script&lang=js&"
import style0 from "./ListaArrendamientos.vue?vue&type=style&index=0&id=581e717f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports